import styled from 'styled-components';

export const ImagesContainer = styled.div`
background: #F0FFE6;
width: 100%;
`;

export const ImagesWrapper = styled.div`
display: flex;
flex-direction: column;
width: 100%;
max-width: 1400px;
margin-left: auto;
margin-right: auto;
padding: 0 25px;
`;

export const ImagesHolder = styled.div`
display: grid;
grid-template-columns: repeat(6, 1fr);
grid-gap: 25px;
justify-content: space-between;

@media screen and (max-width: 1200px){
    grid-template-columns: repeat(3, 1fr);
}

@media screen and (max-width: 768px){
    grid-template-columns: repeat(2, 1fr);
}
`;

export const Image = styled.img`
width: 100%;
height: 100%;
object-fit: cover;
border-radius: 10px;
`;
